import React, { Component } from 'react';
import intl from "react-intl-universal";
import { FormGroup, FormControl, ProgressBar } from "react-bootstrap";
import * as SLCommon from "../../slCommon";


class newPMProjectPhaseEndpoint extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: "",
            params: [],
            queryParams: {},
            showParametersHeaders: true,
            projectName: ""
        };
    }

    componentDidMount() {
        
        if(this.props.isSubLoginType){
            if(this.props.projectName == ""){
                //create custom identifier
                var customProjectName = SLCommon.generateUniqueString(this.props.company);
                this.props.handleProjectName(customProjectName);
                this.setState({ projectName: customProjectName});
            }else{
                this.setState({ projectName: this.props.projectName});
            }
        }else{
            this.setState({ projectName: this.props.projectName});
        }

        const searchParams = new URLSearchParams(window.location.search);
        const queryParams = {};
        for (const [key, value] of searchParams.entries()) {
            // Exclude "packageid"
            if (key !== "packageId" && key !== "cookie") {
                queryParams[key] = value;
            }
        }
        this.setState({ params:  this.props.params});
        this.setState({ queryParams }, ()=>{
            this.updateParamsFromQuery();
        });
    }

    updateParamsFromQuery = () =>{
        var queryParams = this.state.queryParams;
        var params = this.props.params;
        Object.keys(queryParams).forEach(key => {
            let found = false;
            Object.keys(params).forEach(paramKey => {
                if (paramKey === "object") {
                    return; // Skip checking the "object" key
                }
                const paramArray = params[paramKey];
                const index = paramArray.findIndex(obj => obj.name === key);
                if (index !== -1) {
                    paramArray[index].value = queryParams[key];
                    paramArray[index].disable = true;
                    found = true;
                }
            });
            if (!found) {
                if (!params.string) {
                    params.string = [];
                }
                params.string.push({
                    name: key,
                    notEditAble: false,
                    value: queryParams[key],
                    disable: true,
                    options: [],
                    showInUI: true
                });
            }
        });
        
        this.props.handleUpdates({
            params: params
        })
        this.showParametersHeader(params);
    }

    showParametersHeader = (params) =>{
        var temp = []
        Object.keys(params).map(paramType => {
            params[paramType].map((param, index) => {
                if(param.showInUI && (!param.disable || param.disable !== true)){
                    temp.push(param);
                }
            })
        })
        
        if(temp.length > 0 && 
            (
                (this.props.isSubLoginType && this.state.projectName != "") 
                || 
                (!this.props.isSubLoginType && !this.props.skipSteps && this.state.projectName != "")
                ||
                (!this.props.isSubLoginType && this.props.skipSteps && this.state.projectName == "")
            )){
            this.setState({ 
                showParametersHeaders:  true
            });
        }
        else{
            this.setState({ 
                showParametersHeaders:  false
            });
        }
    }

    handleChange = (e, paramType, paramName) => {
        const { value } = e.target;
        const updatedParams = { ...this.state.params };
        updatedParams[paramType] = this.state.params[paramType].map(param => {
            if (param.name === paramName) {
                return { ...param, value: value };
            }
            return param;
        });
        
        this.setState({ params: updatedParams });
        this.props.handleUpdates({
            params: updatedParams
        })
    }

    handleErrorMessage = (message) => {
        this.setState({ errorMessgae: message });
    };

    render() {
        const { params } = this.state;

        const renderParamsOfType = (paramType) => {
            return params[paramType].map((param, index) => {
                if (param.showInUI) {
                    if (paramType === 'object' && param.options) {
                        // Render select box if parameter type is object and it has options
                        return (
                            <div className="form-group" key={`${paramType}-${param.name}-${index}`}>
                                <label htmlFor="selCollectionType">{param.name}:</label>
                                <select
                                    className="form-control round"
                                    id="selCollectionType" 
                                    datafield="CollectionType"
                                    value={param.value}
                                    onChange={(e) => this.handleChange(e, paramType, param.name)}
                                    disabled={param.notEditAble}
                                >
                                    {Object.entries(JSON.parse(param.options)).map(([optionValue, optionLabel]) => (
                                        <option key={optionLabel} value={optionLabel}>
                                            {optionLabel}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        );
                    } else {
                        // Render input field for other types of parameters
                        if(param.disable != undefined && param.disable){
                            return
                        }else{
                            return (
                                <div className="form-label-group" key={`${paramType}-${param.name}-${index}`}>
                                    <p>{param.name}</p>
                                    <FormGroup controlId="firstName" className="form-label-group d-flex">
                                        <FormControl
                                            className="form-control addUserFormControl"
                                            // pattern={"^[\\w\\-]{1,32}$"}
                                            value={param.value}
                                            onChange={(e) => this.handleChange(e, paramType, param.name)}
                                            placeholder="Enter the input data path"
                                            datafield="DataPath"
                                            required
                                            disabled={param.disable ? param.disable : false}
                                        />
                                    </FormGroup>
                                </div>
                            );
                        }
                    }
                }
                return null;
            });
        }


        return (
            <React.Fragment>
                {this.state.errorMessgae ? (
                    <div className='divWarningPMCloud'>
                        {this.state.errorMessgae}
                    </div>
                ) : null}
                <div className="row content">
                <div className='col-sm-8 text-left mainWrapperDiv' style={{ paddingBottom: '120px' }}>
                    <div>
                        <br />
                        <h3>
                            {this.state.showParametersHeaders ? "Parameters" : 'To start the project, click "Start".'}
                        </h3>
                        <br />
                    </div>
                    {this.props.skipSteps && (this.state.projectName == "")  ? 
                        <div>
                            <p>Identifier:</p>
                            <FormGroup controlId="firstName" className="form-label-group d-flex">
                                <FormControl
                                    className="form-control addUserFormControl"
                                    // pattern={"^[\\w\\-]{1,32}$"}
                                    maxLength="32"
                                    value={this.props.projectName}
                                    onChange={(event) => {
                                        if (
                                            event.target.validity.valid ||
                                            event.target.value === ""
                                        )
                                            this.props.handleProjectName(event.target.value);
                                    }}
                                    placeholder={intl.get("Identifier_Name_Placeholder")}
                                    required
                                />
                            </FormGroup>
                        </div>
                    : null}
                    {this.state.showParametersHeaders ? 
                        Object.keys(params).map(paramType => (
                            <React.Fragment key={paramType}>
                                {renderParamsOfType(paramType)}
                            </React.Fragment>
                        )) 
                    : null}
                </div>
                </div>
                <div className={`NextPrevButtonsClass ${this.props.isSubLoginType ? "NextPrevButtonsWithoutFooter" : ""}`}>
                    {this.props.skipSteps ? 
                        <div className="NextButtonDivClass" style={{ float: "right", marginRight: '40px', marginLeft: "30px" }}>
                            <button 
                                className="btn-primary btn btn-default NextButtonClass"
                                disabled={this.props.projectName == ""}
                                onClick={(event) => {
                                this.props.startUploading();
                                }}
                            >START
                            </button>
                        </div>
                    :
                        <div className="NextButtonDivClass" style={{ float: "right", marginRight: '40px', marginLeft: "30px" }}>
                            <button 
                                className="btn-primary btn btn-default NextButtonClass" 
                                disabled={this.props.projectName == ""}
                                onClick={(event) => {
                                if (this.props.checkMovingFromPhaseIItoPhaseIII())
                                    this.props.setPageNumer(3);
                                else this.handleErrorMessage(intl.get("PM_Cloud_PhaseII_Error_Required_Param_Not_Selected"));
                                }}
                            >START
                            </button>
                        </div>
                    }
                </div>
            </React.Fragment>
        );
    }
}

export default newPMProjectPhaseEndpoint;